import { Box } from '@mui/material';
import styled from 'styled-components';

import { TextField } from '@/shared/components/ui/form/components/text-field/text-field';

export const VerificationCodeContainer = styled(Box)`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
`;

export const CodeInput = styled(TextField)`
  && {
    width: 3rem;
    height: 3rem;

    & .MuiInputBase-root {
      height: 100%;
    }

    & .MuiOutlinedInput-input {
      text-align: center;
      ${({ theme }) => theme.typography.p2};
    }
  }
`;
